import React from 'react';
import { RiderAccountInfo, BankOption } from '../types/riderInfoDetail.types';
import '../styles/AccountInfoSection.css';

interface AccountInfoSectionProps {
    accountInfo: RiderAccountInfo;
    bankOptions: readonly BankOption[];
    onBankChange: (value: string) => void;
    onAccountNumberChange: (value: string) => void;
    onAccountHolderChange: (value: string) => void;
    onSave: () => void;
}

const AccountInfoSection: React.FC<AccountInfoSectionProps> = ({
    accountInfo,
    bankOptions,
    onBankChange,
    onAccountNumberChange,
    onAccountHolderChange,
    onSave,
}) => {
    return (
        <div className="section-margin">
            <div className="detail-card">
                <div className="detail-card-header">
                    <i className="fas fa-university card-icon" />
                    <h3 className="card-title">정산정보</h3>
                </div>
                <div className="detail-card-body">
                    <div className="account-form-grid">
                        <div className="account-form-field">
                            <label className="account-form-label">은행</label>
                            <select
                                className="form-input"
                                value={accountInfo.bank}
                                onChange={(e) => onBankChange(e.target.value)}
                            >
                                {bankOptions.map((bank) => (
                                    <option key={bank.value} value={bank.value}>
                                        {bank.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="account-form-field">
                            <label className="account-form-label">계좌번호</label>
                            <input
                                type="text"
                                className="form-input"
                                value={accountInfo.accountNumber}
                                onChange={(e) => onAccountNumberChange(e.target.value)}
                                placeholder="계좌번호 입력"
                                pattern="[0-9]*"
                                inputMode="numeric"
                            />
                        </div>
                        <div className="account-form-field">
                            <label className="account-form-label">예금주</label>
                            <input
                                type="text"
                                className="form-input"
                                value={accountInfo.accountHolder}
                                onChange={(e) => onAccountHolderChange(e.target.value)}
                                placeholder="예금주 입력"
                            />
                        </div>
                    </div>
                    <div className="account-form-footer">
                        <button className="save-btn" onClick={onSave}>
                            <i className="fas fa-save" />
                            저장
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccountInfoSection;
